import React from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import LoginHeader from "./components/LoginHeader.js";
import SideNavigation from "./components/SideNavigation.js";
import ReportsCarousel from "./ReportsCarousel";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Button from "@mui/material/Button";
import WestIcon from "@mui/icons-material/West";
import AADHeader from "./components/AADHeader.js";
const steps = ["Start", "Materiality", "Module", "Input", "Report"];

const ReportDashboard = () => {
  const [isOpen, setIsOpen] = React.useState(true);
  const [loading, setLoading] = React.useState(false);

  const getOpen = (open) => {
    setIsOpen(open);
  };
  const renderHeader = () => {
    const loginType = localStorage.getItem('loginType');
    if (loginType === 'AAD') {
      return <AADHeader />;
    }
    return <LoginHeader heading="" />;
  };
  return (
    <div id="wrapper">
      <div>
        {loading && (
          <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
      </div>
      <div id="sidebar-wrapper" className={isOpen ? "sidebar-open" : "sidebar-close"}>
        <SideNavigation getOpen={getOpen} />
      </div>
      <div id="page-content-wrapper" className={isOpen ? "" : "page-content-wrapper-pd-0"}>
      {renderHeader()}
        <div class="container formpd">
          <div class="flex justify-content-between">
            <div class="steps__containt-hader">
              <h3 class="title">CSRD Report 2023</h3>
              <div role="presentation">
                <Breadcrumbs
                  separator={<NavigateNextIcon fontSize="small" />}
                  aria-label="breadcrumb"
                >
                  <Link underline="hover" color="inherit" href="/standards">
                    Reports
                  </Link>
                  <Link underline="hover" color="inherit" href="/standards">
                    Standards & Frameworks
                  </Link>
                  <Typography color="text.primary">Followed Path</Typography>
                </Breadcrumbs>
              </div>
            </div>
            <div className="stepper-box">
              <Stepper activeStep={3} alternativeLabel>
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel className="step-name">{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
            </div>
          </div>
          <div className="button-box d-flex justify-content-end">
            <Button
              href="standards"
              variant="outlined"
              className="module-btn"
              size="medium"
              sx={{ marginRight: "15px" }}
            >
              <WestIcon fontSize="small" sx={{ marginRight: "4px" }} />
              Back
            </Button>
          </div>
          <div>
            <img
              src="./assets/img/reports/report-dashboard.jpg"
              width={"100%"}
              alt="Report Dashboard"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportDashboard;
